import { useEffect, useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loading } from "@/components/States";
import { api, formatError } from "@/lib/api";

const reason = (j) => (j.applied ? "Already applied" : j.invited ? "Invited" : !j.eligible ? "Missing required certificate" : null);

export function InviteDialog({ handle, onClose }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(null);
  const load = () => api.get(`/employer/invite-options/${handle}`).then((r) => setD(r.data)).catch((e) => { toast.error(formatError(e)); onClose(); });
  useEffect(() => { if (handle) { setD(null); load(); } }, [handle]); // eslint-disable-line react-hooks/exhaustive-deps
  const invite = async (jid) => {
    setBusy(jid);
    try { await api.post("/employer/invites", { handle, job_id: jid }); toast.success("Invite sent"); load(); } catch (e) { toast.error(formatError(e)); }
    setBusy(null);
  };
  return (
    <Dialog open={!!handle} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="invite-dialog" className="w-[calc(100%-2rem)] rounded-2xl sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-ink">Invite {d?.name || "learner"} to apply</DialogTitle>
          <DialogDescription>They get an email and an in-app message. Their email address stays private.{d && ` ${d.invites_left_today} invites left today.`}</DialogDescription>
        </DialogHeader>
        {!d ? <Loading /> : d.jobs.length === 0 ? <p data-testid="invite-no-jobs" className="text-sm text-ink-2">You have no live jobs. Post a job and wait for IDDCR approval first.</p> : (
          <div className="flex flex-col gap-2">
            {d.jobs.map((j) => (
              <div key={j.id} data-testid={`invite-job-${j.id}`} className="flex items-center justify-between gap-3 rounded-lg border border-line p-3">
                <div><p className="font-medium text-ink">{j.title}</p>{reason(j) && <p className="text-xs text-ink-3">{reason(j)}</p>}</div>
                <Button size="sm" data-testid={`invite-send-${j.id}`} disabled={!!reason(j) || busy === j.id || !d.invites_left_today} onClick={() => invite(j.id)} className="rounded-full bg-aqua-solid hover:bg-aqua-solid-hover">
                  <Send className="mr-1.5 h-3.5 w-3.5" />{busy === j.id ? "Sending..." : j.invited ? "Invited" : "Invite"}
                </Button>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
